import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconDoneAll = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M12 4.667l-.94-.94-4.227 4.226.94.94L12 4.667zm2.827-.94L7.773 10.78 4.987 8l-.94.94 3.726 3.727 8-8-.946-.94zM.273 8.94L4 12.667l.94-.94L1.22 8l-.947.94z"
	})
});
export default SvgIconDoneAll;
